import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { BarChart, ResponsiveContainer, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const prepareData = (data) => {
    let result = [];
    //this check later ensures that we are not dividing by zero
    let total = data.map(x => (x.total > 0) ? x.total : 0).reduce((a, b) => a + b);
    //put properties to array and calculate to percentage
    let band1 = total > 0 ? data.map(x => x.thirty / x.total * 100) : [0, 0, 0, 0];
    let band2 = total > 0 ? data.map(x => x.sixty / x.total * 100) : [0, 0, 0, 0];
    let band3 = total > 0 ? data.map(x => x.ninety / x.total * 100) : [0, 0, 0, 0];
    let band4 = total > 0 ? data.map(x => x.overNinety / x.total * 100) : [0, 0, 0, 0];

    //map back to object with properies
    result.push(Object.assign({ name: "1-30" }, band1));
    result.push(Object.assign({ name: "31-60" }, band2));
    result.push(Object.assign({ name: "61-90" }, band3));
    result.push(Object.assign({ name: "> 90" }, band4));
    return result;

}
const rad = [10, 10, 0, 0]

const ITradeChart = ({ data, yLabel, header, xLabel }) => {

    let prepared = prepareData(data);

    return (
        <React.Fragment>
            {header && <span className='underlined-title-wrapper'>
                <span className='underlined-title'>{header}</span>
            </span>}

            <ResponsiveContainer width="99%" height={300} >
                <BarChart data={prepared} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>

                    <CartesianGrid vertical={false} stroke="#8d949e"></CartesianGrid>
                    <YAxis stroke="#8d949e" tickFormatter={(x) => `${x} %`} interval={0} type="number" label={{ value: yLabel, angle: -90, fontSize: "0.8em", dx: -38, fill: "#8d949e" }} />
                    <XAxis stroke="#8d949e" dataKey="name" type="category" label={{ value: xLabel, fontSize: "0.8em", dy: 20, fill: "#8d949e" }} />
                    <defs>

                    </defs>
                    <Tooltip cursor={false}  content={<CustomTooltip />} wrapperStyle={tooltipStyle} />
                    <Bar barSize={25} dataKey="0" fill={`url('${window.location.pathname}${window.location.search}#i-trade-1')`} radius={rad}>
                    </Bar>
                    <Bar barSize={25} dataKey="1" fill={`url('${window.location.pathname}${window.location.search}#i-trade-2')`} radius={rad}>
                    </Bar>
                    <Bar barSize={25} dataKey="2" fill={`url('${window.location.pathname}${window.location.search}#i-trade-3')`} radius={rad}>
                    </Bar>
                    <Bar barSize={25} dataKey="3" fill={`url('${window.location.pathname}${window.location.search}#i-trade-4')`} radius={rad}>
                    </Bar>
                    <Bar barSize={25} dataKey="4" fill={`url('${window.location.pathname}${window.location.search}#i-trade-5')`} radius={rad}>
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </React.Fragment>

    )

}

const tooltipStyle = {
    textAlign: 'center',
    fontSize: '0.8em',
    padding: "0.35em 2em",
    background: "#FFF",
    border: "1px solid #DEDEDE",
    boxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)",
    WebkitBoxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)"
}
const CustomTooltip = ({ label, active, payload }) => {
    if (active) {
        return (
            <div className="payment-chart-tooltip">
                {payload.map((d, i) =>
                    <div className="is-flex" key={i} style={{ flexBasis: "15%", textAlign: "center", justifyContent: 'center' }}>
                        <div style={{ backgroundColor: getColor(i), marginRight: "5px", width: "20px", height: "0.8em", marginTop: "0.5em" }}></div>
                        <div style={{ fontWeight: "600", fontSize: "1.2em", minWidth: "4em" }}>{isNaN(d.payload[i]) ? "-" : `${Math.round((d.payload[i] + Number.EPSILON) * 100) / 100} %`}</div>
                    </div>
                )}
                <div style={{ fontSize: "1em" }}>{`${payload[0].payload.name} `}<Translate id="Report.Itrade.DelayInDays"></Translate></div>
            </div>
        )
    }
    return null;
}
const getColor = (i) => {
    if (i === 4)
        return "#a0d406";
    if (i === 3)
        return "#f4af24";
    if (i === 2)
        return "#e7445e";
    if (i === 1)
        return "#ae7199";
    if (i === 0)
        return "#61b4e4";
}

export default withLocalize(ITradeChart);

